<listo-select i18n-label label="Year of the car" [options]="years" [form]="form" name="year" [required]="true" [loading]="yearsLoading"></listo-select>

<listo-select *ngIf="shouldShowMakers()" i18n-label label="Make" [options]="makers" [form]="form" name="maker" [required]="true" [loading]="makersLoading"></listo-select>
<listo-select *ngIf="shouldShowModels()" i18n-label label="Model" [options]="models" [form]="form" name="model" [required]="true" [loading]="modelsLoading"></listo-select>

